import React from "react";
import { Link } from "react-router-dom";
import { User as UserIcon, CheckCircle2 } from "lucide-react";
import { Step, Field } from "@/pages/booking/bookingUi";

export const CustomerDetailsStep = ({ form, setForm, prefillStatus, rebook }) => (
  <Step n="01" title="Your details" Icon={UserIcon}>
    {prefillStatus === "filled" && (
      <div data-testid="booking-prefill-badge" className="mb-4 inline-flex items-center gap-2 border border-emerald-600/40 bg-emerald-500/10 px-3 py-1.5 text-xs text-emerald-600 dark:text-emerald-300">
        <CheckCircle2 size={14} />
        {rebook ? "Rebooking — your details and vehicle are copied over. Just pick a date and time." : "Filled from your account — feel free to edit anything below."}
      </div>
    )}
    {prefillStatus === "guest" && (
      <p data-testid="booking-login-hint" className="mb-4 text-xs text-zinc-500">
        Have an account?{" "}
        <Link to="/account/login?next=/book" className="text-brand-red underline underline-offset-4 hover:text-white transition-colors">
          Log in to autofill your details
        </Link>{" "}
        — or just book as a guest below.
      </p>
    )}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label="Full name">
        <input data-testid="booking-name" required value={form.customer_name} onChange={(e) => setForm({ ...form, customer_name: e.target.value })} className="ta-input" placeholder="Jane Citizen" />
      </Field>
      <Field label="Phone">
        <input data-testid="booking-phone" required type="tel" value={form.customer_phone} onChange={(e) => setForm({ ...form, customer_phone: e.target.value })} className="ta-input" placeholder="0412 345 678" />
      </Field>
      <Field label="Email">
        <input data-testid="booking-email" required type="email" value={form.customer_email} onChange={(e) => setForm({ ...form, customer_email: e.target.value })} className="ta-input" placeholder="you@example.com" />
      </Field>
    </div>
  </Step>
);
